var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLossSegment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Loss Segment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.907775,250.054217 L12.2535857,172.819662 L13.3029752,169.659591 C48.5602276,65.7606432 145.745799,-0.088617627 250.137215,-8.93321277e-05 L249.924848,250.009273 L249.942526,250.008729 L249.907775,250.054217 Z",
    fill: "#810645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossSegment);
export default __webpack_public_path__ + "static/media/Loss-Segment.23d5765c914d431dba0d5262b012ac88.svg";
export { ForwardRef as ReactComponent };